import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sync-all-banner',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule],
  templateUrl: './sync-all-banner.component.html',
  host: {
    class: 'block w-full',
  },
})
export class SyncAllBannerComponent {
  @Input() disabled = false;
  @Output() readonly syncAll = new EventEmitter<void>();

  onSyncAll(): void {
    if (this.disabled) {
      return;
    }
    this.syncAll.emit();
  }
}
